import { useState } from 'react'
import { toast } from 'react-toastify'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { Flex, colors } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { Input } from 'components/Input/Input'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { Card, CardBody } from 'components/Card/Card'
import { IFoodProfile } from 'types/foodLogistics/foodProfile.interface'
import { FOOD_PROVISIONING_MODES, foodProfilesMock } from '../foodData'

export const ProfilesTab = () => {
  const [profiles] = useState<IFoodProfile[]>(foodProfilesMock)
  const [selectedId, setSelectedId] = useState<number>(profiles[0]?.id)
  const [defaults, setDefaults] = useState(profiles[0]?.defaults || {})
  const [stickyKitchen, setStickyKitchen] = useState(profiles[0]?.stickyKitchen || 'None — Auto Assign')

  const selected = profiles.find((p) => p.id === selectedId)!

  const handleSelect = (p: IFoodProfile) => {
    setSelectedId(p.id)
    setDefaults(p.defaults)
    setStickyKitchen(p.stickyKitchen)
  }

  const modeOptions = FOOD_PROVISIONING_MODES.map((m) => ({ label: m, value: m }))
  const kitchenOptions = [
    { label: 'None — Auto Assign', value: 'None — Auto Assign' },
    { label: 'Main Kitchen', value: 'Main Kitchen' },
    { label: 'North Kitchen', value: 'North Kitchen' },
  ]

  return (
    <Flex gap='1rem' width='100%' main>
      <Flex width='40%' minWidth='20rem'>
        <Container>
          <ContainerHeader>
            <TitleText weight='700'>Employee Food Registry</TitleText>
          </ContainerHeader>
          <ContainerContent gap='0.5rem'>
            <Input placeholder='Type employee name…' nomarg search />
            <OtherText grey>QUICK SELECT</OtherText>
            {profiles.map((p) => (
              <Card
                key={p.id}
                onClick={() => handleSelect(p)}
                fullBorder={selectedId === p.id ? colors.orange : undefined}
                hoverBorder
              >
                <CardBody>
                  <BodyText weight='600'>{p.name}</BodyText>
                  <OtherText grey>{p.dept}</OtherText>
                </CardBody>
              </Card>
            ))}
          </ContainerContent>
        </Container>
      </Flex>
      <Flex width='100%'>
        <Container>
          <ContainerHeader>
            <TitleText weight='700'>Edit Profile — {selected.name}</TitleText>
          </ContainerHeader>
          <ContainerContent gap='1rem'>
            <Flex gap='1rem' width='100%'>
              <Flex column gap='0.25rem' width='100%'>
                <OtherText grey>ROLE</OtherText>
                <BodyText>{selected.role}</BodyText>
              </Flex>
              <Flex column gap='0.25rem' width='100%'>
                <OtherText grey>DEPARTMENT</OtherText>
                <BodyText>{selected.dept}</BodyText>
              </Flex>
            </Flex>
            <Flex column gap='0.5rem'>
              <OtherText grey>DIETARY REQUIREMENT (read-only · HRDL Core)</OtherText>
              <Flex wrap gap='0.25rem'>
                {selected.tags.map((t) => (
                  <StatusPill key={t} status='accent'>{t}</StatusPill>
                ))}
              </Flex>
            </Flex>
            <BodyText weight='600'>Provisioning mode defaults — per meal window</BodyText>
            {Object.keys(defaults).map((m) => (
              <Flex key={m} gap='0.75rem' center width='100%'>
                <BodyText style={{ width: '7rem' }}>{m}</BodyText>
                <HonestSelectInput
                  width='100%'
                  options={modeOptions}
                  defaultValue={defaults[m]}
                  onChange={(v: any) => setDefaults({ ...defaults, [m]: v.value })}
                  name={m}
                  labelText=''
                />
              </Flex>
            ))}
            <HonestSelectInput
              labelText='Sticky kitchen assignment'
              options={kitchenOptions}
              defaultValue={stickyKitchen}
              onChange={(v: any) => setStickyKitchen(v.value)}
              name='stickyKitchen'
            />
            <Flex>
              <Button variant='primary' onClick={() => toast.success('Profile saved — applies from next intent generation (audited)')}>
                Save
              </Button>
            </Flex>
          </ContainerContent>
        </Container>
      </Flex>
    </Flex>
  )
}
